"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _excluded = ["moreText", "lessText"];
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    MoreLessWrapper: {
      marginBottom: '15px',
      marginLeft: '-5px'
    },
    showMoreLess: {
      backgroundColor: theme.palette.background.grey
    },
    showMoreLessContent: {
      padding: '30px 15px 14px 15px'
    },
    showMoreLessText: {
      color: theme.palette.text.secondary,
      cursor: 'pointer',
      fontWeight: 900,
      fontSize: '14px'
    },
    expand: {
      color: theme.palette.text.secondary,
      padding: '0px',
      fontSize: '14px',
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      fontWeight: 900,
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },
    expandOpen: {
      transform: 'rotate(180deg)'
    }
  };
});
var MoreLessContent = function MoreLessContent(_ref) {
  var moreText = _ref.moreText,
    lessText = _ref.lessText,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var classes = useStyles();
  var _React$useState = _react.default.useState(false),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    expanded = _React$useState2[0],
    setExpanded = _React$useState2[1];
  var handleExpandClick = function handleExpandClick() {
    setExpanded(!expanded);
  };
  return __jsx(_core.Grid, {
    item: true,
    xs: 12
  }, __jsx("div", {
    className: classes.MoreLessWrapper,
    onClick: handleExpandClick
  }, __jsx(_IconButton.default, {
    className: (0, _clsx2.default)(classes.expand, (0, _defineProperty2.default)({}, classes.expandOpen, expanded)),
    "aria-expanded": expanded,
    "aria-label": expanded ? 'Show Less' : 'Show More'
  }, __jsx(_ExpandMore.default, null)), __jsx("span", {
    className: classes.showMoreLessText
  }, expanded ? "".concat(lessText) : "".concat(moreText))), __jsx("div", {
    className: classes.showMoreLess
  }, __jsx(_Collapse.default, {
    in: expanded,
    timeout: "auto",
    unmountOnExit: true
  }, __jsx("div", {
    className: classes.showMoreLessContent
  }, props.children))));
};
var _default = MoreLessContent;
exports.default = _default;